import { ItemDocumentFinderThemeSizeConfig } from './types';

const medium: ItemDocumentFinderThemeSizeConfig = {
  itemDocumentFinder: {},
};

export default medium;
